import { render, staticRenderFns } from "./BaseLayerSelectPlugin.vue?vue&type=template&id=3bd1f98f&scoped=true"
import script from "./BaseLayerSelectPlugin.vue?vue&type=script&lang=js"
export * from "./BaseLayerSelectPlugin.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./BaseLayerSelectPlugin.vue?vue&type=style&index=0&id=3bd1f98f&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3bd1f98f",
  null
  ,true
)

export default component.exports